// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"985d5755","246":"a8a23b14","453":"220ec620","480":"eaf9a6a5","712":"adabe56c","774":"0cff55a2","784":"072f0640","859":"8bd862df"}[chunkId] + ".chunk.js";
};